module.exports = __webpack_public_path__ + "static/media/ranswer.ff23372f.png";